const footerLinks = [
  { label: "最新章节", href: "#chapters" },
  { label: "连载进度", href: "#progress" },
  { label: "剧情简介", href: "#story" },
  { label: "主要角色", href: "#characters" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/15">
                <i className="ri-leaf-fill text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                天才医仙<span className="text-accent-400">漫画</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/80">
              天才医仙漫画最新章节免费追更，收藏自动提醒，连载进度一眼便知。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-background-50">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-100/80 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50">追更指南</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80">
              每周二、周四、周六固定更新，最新章节第一时间同步。收藏本站即可开启自动追更，再也不怕错过最新话。
            </p>
            <a
              href="#follow"
              className="mt-4 inline-flex whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-bookmark-line mr-1.5"></i>收藏追更
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/70">
            © {new Date().getFullYear()} 天才医仙漫画追更站 · 仅供参考与交流
          </p>
          <p className="text-xs text-background-100/70">本站内容仅供追更参考，版权归原作品所有</p>
        </div>
      </div>
    </footer>
  );
}